export default __webpack_public_path__ + "static/media/danji_big.0af1c0c4.jpg";